module.exports = __webpack_public_path__ + "static/media/about-congresso.4c6808a3.jpg";